import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractDocumentAggregateTranslation.Delete.IRequest;
type Response = Api.Core.ContractDocumentAggregateTranslation.Delete.IResponse;
type Headers = Api.Core.ContractDocumentAggregateTranslation.Delete.IHeaders;
const url = '/api/Sales/Contract/DocumentAggregateTranslation/:id';
export default async function contractDocumentAggregateTranslationDeleteApi(
  params: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params, undefined),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
